import { render, staticRenderFns } from "./registered.md?vue&type=template&id=a4961aa4&"
import script from "./registered.md?vue&type=script&lang=js&"
export * from "./registered.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports